// extracted by mini-css-extract-plugin
module.exports = {"paddings":"container_paddings__tnF4I"};